import React from "react"
import { MenuItem, Button } from "@blueprintjs/core"
import { ItemPredicate, ItemRendererProps, Select } from "@blueprintjs/select"

interface SourceFilterProps {
  availableSources: string[]
  selectedSource: string
  onSourceChange: (source: string) => void
  disabled?: boolean
}

const SourceFilter: React.FC<SourceFilterProps> = ({
  availableSources,
  selectedSource,
  onSourceChange,
  disabled = false,
}) => {
  const renderSource = (source: string, { handleClick, modifiers }: ItemRendererProps) => {
    if (!modifiers.matchesPredicate) return null

    return (
      <MenuItem
        active={modifiers.active}
        key={source}
        text={source}
        onClick={handleClick}
        roleStructure="listoption"
        icon={selectedSource === source ? "tick" : "blank"}
      />
    )
  }

  const filterSources: ItemPredicate<string> = (query, source) => {
    return source.toLowerCase().includes(query.toLowerCase())
  }

  const handleSourceSelect = (source: string) => {
    onSourceChange(source)
  }

  const getButtonText = () => {
    return selectedSource || "Select source..."
  }

  return (
    <Select
      items={availableSources}
      itemRenderer={renderSource}
      itemPredicate={filterSources}
      onItemSelect={handleSourceSelect}
      popoverProps={{ minimal: true }}
      resetOnSelect={true}
      disabled={disabled}
      filterable={false}
    >
      <Button text={getButtonText()} rightIcon="caret-down" disabled={disabled} fill />
    </Select>
  )
}

export default SourceFilter
